import http from '../http';

const orders = '/connex/services/orders';

export const api = {
  unInvoice: (entityRef, body) => http.post(`${orders}/${entityRef}/invoices/un-invoice`, body),
};
